import React, { useMemo, useState } from "react";
import style from "./index.module.scss";
import { Button, Empty } from "antd";
import config from "../../../../config";
import { getQiniuFileName } from "../../../../Utils/filter";
import DocViewer from "../../../../components/PreviewSourceModal/components/Viewer/Components/DocViewer";

interface Props {
    src: string;
    officeUrl: string;
    onDownload?: () => void;
    canDownload?: boolean;
}

//课件类型
const passType = {
    ppt: ["ppt", "pptx"],
    word: ["doc", "docx"],
    excel: ["xls", "xlsx"],
    pdf: ["pdf"],
    href: ["html"],
    pic: ["png", "jpg", "jpeg", "gif"],
    txt: ["txt", "csv"],
    video: ["mp4", "mp3"],
    polyv: ["polyv"],
    compression: ["rar", "7z", "zip"]
};

export default function ExamFileView({
    src,
    officeUrl,
    onDownload,
    canDownload = true
}: Props) {
    const [open, setOpen] = useState(true);

    type keyType = keyof typeof passType;
    const fileType = useMemo((): string => {
        for (let type of Object.keys(passType)) {
            if (
                passType[type as keyType].includes(src.split(".").pop() || "")
            ) {
                return type;
            }
        }
        return "";
    }, [src]);

    function cli() {
        setOpen(open => !open);
    }

    const node = useMemo(() => {
        let doc = null;
        if (src.includes(config.QiNiuDownloadUrl)) {
            doc = (
                <div className={style.empty}>
                    <Empty description="预览附件功能上线前添加的附件，仅能通过“下载附件”下载到本地查看" />
                </div>
            );
        } else if (["video"].includes(fileType)) {
            doc = <video controls className={style.video} src={src} />;
        } else if (["ppt", "word", "excel", "pdf"].includes(fileType)) {
            doc = <DocViewer src={officeUrl + src} className={style.doc} />;
        } else if (["pic"].includes(fileType)) {
            doc = <img src={src} />;
        } else {
            doc = (
                <div className={style.empty}>
                    <Empty description='该类型文件不支持在线预览，请点击"下载附件"，下载到本地查看' />
                </div>
            );
        }
        return (
            <div className={style.docbg}>
                <h1>
                    <div className={style.title}>{getQiniuFileName(src)}</div>
                    <div className={style.tools}>
                        <Button
                            type="link"
                            icon={open ? "up" : "down"}
                            size="small"
                            onClick={cli}>
                            {open ? "收起" : "展开"}
                        </Button>
                        {canDownload && (
                            <Button
                                type="link"
                                size="small"
                                icon="download"
                                href={src}
                                onClick={onDownload}>
                                下载附件
                            </Button>
                        )}
                    </div>
                </h1>
                <div className={open ? style.open : style.notOpen}>{doc}</div>
            </div>
        );
    }, [src, fileType, officeUrl, open]);

    return <div className={style.root}>{node}</div>;
}
